import React from "react";
import { Pressable, Box } from "native-base";
import { COLORS } from "../../utils/colors";

const ToggleSwitch = ({ isOn = false, onToggle = () => { } }) => {
    return (
        <Pressable onPress={onToggle}>
            <Box
                width="50px"
                height="28px"
                borderRadius="14px"
                bg={isOn ? COLORS.TOGGLE_ACTIVE_BUTTON_COLOR : "#E5E5E5"}
                justifyContent="center"
                paddingX="2px"
                style={{
                    transition: "background-color 0.3s ease",
                }}
            >
                <Box
                    width="24px"
                    height="24px"
                    borderRadius="12px"
                    bg={COLORS.WHITE_COLOR}
                    style={{
                        transform: isOn ? "translateX(22px)" : "translateX(0px)",
                        transition: "transform 0.3s ease",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                    }}
                />
            </Box>
        </Pressable>
    );
};

export default ToggleSwitch;

